import type { Brand, Locale } from "@borealis/layout-express";
import type { Consent } from "@mobility-item-page/types";
import type { Logger } from "pino";
import React from "react";
import type { FeatureToggles } from "../types/unleash.ts";
import type { TabId } from "../utils/tabs.ts";

export type GoogleMapsEmbed = {
  apiUrl: string;
  apiKey: string;
};

export type AppConfig = {
  logger?: Logger;
  locale: Locale;
  assetsBaseUrl?: string;
  isMobile: boolean;
  featureToggles: FeatureToggles;
  tabs: TabId[];
  logInId?: number;
  mountOrigin?: string;
  brand: Brand;
  googleMapsEmbed: GoogleMapsEmbed | null;
  consent: Consent;
  helpCenter: string;
};

const AppConfigContext = React.createContext<AppConfig | undefined>(undefined);

type AppConfigProviderProps = {
  children: React.ReactNode;
  appConfig: AppConfig;
};

export function AppConfigProvider(props: AppConfigProviderProps) {
  const { children, appConfig } = props;

  return <AppConfigContext value={{ ...appConfig }}>{children}</AppConfigContext>;
}

export function useAppConfig() {
  const context = React.useContext(AppConfigContext);
  if (typeof context === "undefined") {
    throw new Error("useAppConfig must be used within an AppConfigProvider");
  }
  return context;
}
